var _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase2Fig1ProbeLifecycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The life of one architecture decision")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Six independent readings stand between a draft decision and a locked one")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 250,
    width: 140,
    height: 120,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 284,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "Entry gate"), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 308,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "written trigger"), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 325,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "and skip criteria"), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 349,
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "probe only where"), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 364,
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "reversal is costly"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 270,
    width: 112,
    height: 80,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 278,
    y: 304,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "v1 doc"), /*#__PURE__*/React.createElement("text", {
    x: 278,
    y: 326,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "with source"), /*#__PURE__*/React.createElement("text", {
    x: 278,
    y: 340,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "markers"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 120,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 146,
    textAnchor: "middle"
  }, "clarify the thinking"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 172,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 198,
    textAnchor: "middle"
  }, "challenge assumptions"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 224,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 250,
    textAnchor: "middle"
  }, "evidence basis"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 276,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 302,
    textAnchor: "middle"
  }, "alternative viewpoints"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 328,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 354,
    textAnchor: "middle"
  }, "implications"), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 380,
    width: 180,
    height: 42,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 406,
    textAnchor: "middle"
  }, "question the question"), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 446,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "six lenses, run in parallel, no shared context"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 230,
    width: 150,
    height: 160,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 262,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Synthesis"), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 286,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "a fixed 10-section"), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 302,
    fontSize: 11.5,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "structure, read cold"), /*#__PURE__*/React.createElement("line", {
    x1: 618,
    y1: 318,
    x2: 728,
    y2: 318,
    stroke: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 342,
    fontSize: 11,
    letterSpacing: "0.06em",
    fill: "#7C3AED",
    textAnchor: "middle",
    fontWeight: 600
  }, "LAST SECTION"), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 360,
    fontSize: 11.5,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "THE META-"), /*#__PURE__*/React.createElement("text", {
    x: 673,
    y: 375,
    fontSize: 11.5,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "QUESTION"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788,
    y: 270,
    width: 112,
    height: 80,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 844,
    y: 304,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "v2 doc"), /*#__PURE__*/React.createElement("text", {
    x: 844,
    y: 326,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "reshaped by"), /*#__PURE__*/React.createElement("text", {
    x: 844,
    y: 340,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "what came back"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 250,
    width: 212,
    height: 120,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 1046,
    y: 284,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Ledger entry"), /*#__PURE__*/React.createElement("text", {
    x: 1046,
    y: 308,
    fontSize: 12,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "locked, with written"), /*#__PURE__*/React.createElement("text", {
    x: 1046,
    y: 325,
    fontSize: 12,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "reversal triggers"), /*#__PURE__*/React.createElement("text", {
    x: 1046,
    y: 350,
    fontSize: 11.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "a later entry may supersede it"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 310,
    x2: 216,
    y2: 310
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 310 C 356 310, 356 141, 374 141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 310 C 356 310, 356 193, 374 193"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334,
    y1: 310,
    x2: 374,
    y2: 253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334,
    y1: 310,
    x2: 374,
    y2: 299
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 310 C 356 310, 356 351, 374 351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 310 C 356 310, 356 403, 374 403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 141 C 580 141, 580 300, 594 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 193 C 580 193, 580 300, 594 300"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558,
    y1: 253,
    x2: 594,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558,
    y1: 299,
    x2: 594,
    y2: 303
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 351 C 580 351, 580 310, 594 310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 403 C 580 403, 580 310, 594 310"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 310,
    x2: 936,
    y2: 310
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 748,
    y1: 310,
    x2: 784,
    y2: 310,
    stroke: "#7C3AED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 304 l10 6 l-10 6 z",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("text", {
    x: 766,
    y: 404,
    fontSize: 11,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "the founder reads it cold,"), /*#__PURE__*/React.createElement("text", {
    x: 766,
    y: 419,
    fontSize: 11,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "answers in one response"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#D4DDD6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M936 304 l10 6 l-10 6 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 304 l10 6 l-10 6 z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278 470 v26 h566 v-26",
    fill: "none",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 561,
    y: 522,
    fontSize: 13,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "the difference between v1 and v2 is the probe's measurable effect"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 580,
    fontSize: 13.5,
    fill: "#1A2F2A",
    fontWeight: 500
  }, "A lens sees the draft and the code it claims to describe, never the other lenses, so six agreements are six independent ones.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase2Fig1ProbeLifecycle);
export default __webpack_public_path__ + "static/media/case2-fig1-probe-lifecycle.73d0c7a696e8250d3fe52a43e7af3e84.svg";
export { ForwardRef as ReactComponent };